import { Component } from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { intlShape, handleUnknownErrors, showSuccess } from "lcm-iot-commons";
import { MenuItem } from "react-bootstrap";
import ItemMenu from "lcm-iot-commons/client/lib/components/ItemMenu";

import ConfirmationModal from "lcm-iot-commons/client/lib/components/ConfirmationModal";
import { technicalUserShape } from "../../shapes/technicalUsersShape";
import { accessRightsShape } from "../../shapes/accessRightsShape";
import TechnicalUserModal from "./TechnicalUserModal";
import {
  resetTechnicalUserPassword,
  deleteTechnicalUser,
} from "../../api/technicalUserApi";

type OwnProps = {
  technicalUser?: technicalUserShape;
  accessRights?: accessRightsShape;
  onTechnicalUserRemoved?: $TSFixMeFunction;
  intl?: intlShape;
};

type State = $TSFixMe;

const defaultProps: Partial<OwnProps> = {
  technicalUser: undefined,
  accessRights: undefined,
  onTechnicalUserRemoved: undefined,
  intl: undefined,
};

type Props = OwnProps & typeof defaultProps;

class TechnicalUserItem extends Component<Props, State> {
  // eslint-disable-next-line react/static-property-placement
  static readonly defaultProps = defaultProps;

  constructor(props: Props) {
    super(props);
    /* istanbul ignore next */
    this.handleOnDeleteClick = this.handleOnDeleteClick.bind(this);
    this.handleOnResetClick = this.handleOnResetClick.bind(this);
    this.onCloseModal = this.onCloseModal.bind(this);
    this.onResetConfirmationModal = this.onResetConfirmationModal.bind(this);
    this.onDeleteConfirmationModal = this.onDeleteConfirmationModal.bind(this);
    this.state = {
      deleting: false,
      resetting: false,
      showModal: false,
      newPassword: null,
    };
  }

  onCloseModal() {
    this.resetActionsState();
  }

  async onResetConfirmationModal() {
    const { intl, technicalUser } = this.props;
    const { resetting } = this.state;
    this.resetActionsState();
    if (resetting) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      return resetTechnicalUserPassword(technicalUser.id)
        .then((newPassword) => {
          this.setState({
            showModal: true,
            newPassword: (newPassword as $TSFixMe).password,
          });
        })
        .catch((apiErrors) => {
          handleUnknownErrors(
            apiErrors,
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({ id: "api.error.unknown" }),
          );
        });
    }
    return null;
  }

  onDeleteConfirmationModal() {
    const { intl, technicalUser, onTechnicalUserRemoved } = this.props;
    const { deleting } = this.state;
    this.resetActionsState();
    if (deleting) {
      // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
      deleteTechnicalUser(technicalUser.id)
        .then(() => {
          showSuccess(
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({
              id: "technical_user.actions.delete.notification",
            }),
          );
          // @ts-expect-error TS(2722) FIXME: Cannot invoke an object which is possibly 'undefin... Remove this comment to see the full error message
          onTechnicalUserRemoved(technicalUser);
        })
        .catch((apiErrors) => {
          handleUnknownErrors(
            apiErrors,
            // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
            intl.formatMessage({ id: "api.error.unknown" }),
          );
        });
    }
    return null;
  }

  resetActionsState() {
    this.setState({ deleting: false, resetting: false, showModal: false });
  }

  handleOnDeleteClick() {
    this.setState({ deleting: true });
  }

  handleOnResetClick() {
    this.setState({ resetting: true });
  }

  render() {
    const { technicalUser, accessRights, intl } = this.props;
    const { newPassword, showModal, resetting, deleting } = this.state;
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    const canUpdateAndDelete = accessRights.canUpdate;
    const technicalUserModal =
      showModal && newPassword ? (
        <TechnicalUserModal
          // @ts-expect-error TS(2322) FIXME: Type '{ id: string; show: any; titleText: string; ... Remove this comment to see the full error message
          id="modal-dialog"
          show={showModal}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          titleText={intl.formatMessage({
            id: "technical_user_modal.reset_password.modal_title",
          })}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          contextBodyText={intl.formatMessage({
            id: "technical_user_modal.reset_password.modal_message",
          })}
          onClose={this.onCloseModal}
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          username={technicalUser.email}
          password={newPassword}
        />
      ) : null;
    const resetConfirmationModal = resetting ? (
      <ConfirmationModal
        id="reset-confirmation-modal"
        show
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        titleText={intl.formatMessage({
          id: "password_reset.actions.modal_title",
        })}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        messageText={intl.formatMessage(
          { id: "password_reset.actions.modal_message" },
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          { technicalUser: technicalUser.email },
        )}
        onConfirm={this.onResetConfirmationModal}
        onClose={this.onCloseModal}
      />
    ) : null;
    const deleteConfirmationModal = deleting ? (
      <ConfirmationModal
        id="delete-confirmation-modal"
        show
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        titleText={intl.formatMessage({
          id: "technical_user_delete.actions.modal_title",
        })}
        // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
        messageText={intl.formatMessage(
          { id: "technical_user_delete.actions.modal_message" },
          // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
          { technicalUser: technicalUser.email },
        )}
        onConfirm={this.onDeleteConfirmationModal}
        onClose={this.onCloseModal}
      />
    ) : null;

    return (
      <li className="list-item">
        <div className="list-item-image">
          <span className="icon lcm-iot-icon-user" />
        </div>
        <div className="list-item-content">
          {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
          <div className="list-item-header">{technicalUser.email}</div>
          <div className="list-item-details">
            <FormattedMessage id="label.technical_user_id" />
            {": "}
            {/* @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'. */}
            {technicalUser.id}
          </div>
        </div>
        <div className="list-item-actions">
          <ItemMenu>
            <MenuItem
              id="item-reset"
              onSelect={this.handleOnResetClick}
              className={!canUpdateAndDelete ? "disabled" : ""}
              disabled={!canUpdateAndDelete}
            >
              <FormattedMessage id="button.reset_password" />
            </MenuItem>
            <MenuItem
              id="item-delete"
              onSelect={this.handleOnDeleteClick}
              className={!canUpdateAndDelete ? "disabled" : ""}
              disabled={!canUpdateAndDelete}
            >
              <FormattedMessage id="button.delete" />
            </MenuItem>
          </ItemMenu>
        </div>
        {technicalUserModal}
        {resetConfirmationModal}
        {deleteConfirmationModal}
      </li>
    );
  }
}

// @ts-expect-error TS(2769) FIXME: No overload matches this call.
export default injectIntl(TechnicalUserItem);
